import { render } from "./Naviagation.vue?vue&type=template&id=3e5aea5e&ts=true"
import script from "./Naviagation.vue?vue&type=script&lang=ts"
export * from "./Naviagation.vue?vue&type=script&lang=ts"

import "./Naviagation.vue?vue&type=style&index=0&id=3e5aea5e&lang=scss"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__